import { useTranslation } from "react-i18next";
import { NavigatableText } from "../../../util/NavigatableText";
import { formatLocalizedDateTime } from "../../../util/formatting";

interface SummaryInformationProps {
  dateCreated: Date;
  project: string;
  projectId: string;
  handleProjectClicked: (siteId: string) => void;
}

export const SummaryInformation = ({
  dateCreated,
  project,
  projectId,
  handleProjectClicked,
}: SummaryInformationProps) => {
  const { t } = useTranslation();

  const handleProjectNameClick = (params: { [key: string]: string }) => {
    if (handleProjectClicked) {
      handleProjectClicked(params.projectId);
    }
  };

  return (
    <div>
      <table className="summary-table">
        <tbody>
          <tr>
            <td className={"align-right"}>
              {t("translations:created-date")}:&nbsp;&nbsp;
            </td>
            <td>{formatLocalizedDateTime(dateCreated)}</td>
          </tr>
          <tr>
            <td className={"align-right"}>
              {t("translations:construction-project")}:&nbsp;&nbsp;
            </td>
            <td>
              <NavigatableText
                text={project}
                params={{ projectId: projectId }}
                type="callback"
                callBack={handleProjectNameClick}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
